<template>
  <div class="help-tip" :class="{ 'help-tip--in-place': isInPlace }">
    <!-- Collapsed view -->
    <div 
      v-if="!isInPlace"
      class="collapsed-help-tip" 
      @click="isExpanded = !isExpanded"
    >
      <img class="info-icon-small" :src="help_style === 'alert' ? require('../assets/img/alert.svg') : require('../assets/img/info_tip.svg')">
    </div>

    <div v-if="isInPlace" class="help-popup help-popup--in-place">
      <div class="popup-content" v-if="help_style=='empty'">
        <img class="info-icon" src="../assets/img/info_tip.svg">
        <div class="info-text">
          <slot />
        </div>
      </div>
      <div class="popup-content alert-style" v-else-if="help_style=='alert'">
        <img class="alert-icon" src="../assets/img/alert.svg">
        <div class="alert-text">
          <slot />
        </div>
      </div>
      <div class="popup-content" v-else>
        <img class="info-icon" src="../assets/img/info_tip.svg">
        <div class="info-text">
          <slot />
        </div>
      </div>
    </div>

    <!-- Expanded popup -->
    <div v-if="isExpanded && !isInPlace" class="help-popup-overlay" @click="isExpanded = false">
      <div class="help-popup" @click.stop>
        <div class="popup-content" v-if="help_style=='empty'">
          <img class="info-icon" src="../assets/img/info_tip.svg">
          <div class="info-text">
            <slot />
          </div>
        </div>
        <div class="popup-content alert-style" v-else-if="help_style=='alert'">
          <img class="alert-icon" src="../assets/img/alert.svg">
          <div class="alert-text">
            <slot />
          </div>
        </div>
        <div class="popup-content" v-else>
          <img class="info-icon" src="../assets/img/info_tip.svg">
          <div class="info-text">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  name: 'HelpTip',
  props: {
    help_style: {
      type: String,
      default: "",
    },
    isInPlace: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const isExpanded = ref(false);
    return {
      isExpanded,
    };
  },
};

</script>

<style lang="scss" scoped>

.help-tip {
  position: relative;
  display: inline-flex;
}

.help-tip--in-place {
  display: block;
  width: 100%;
}

.collapsed-help-tip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border-radius: 6px;
  border: 1px solid rgb(198, 214, 228);
  background-color: var(--color-white-100);
  cursor: pointer;
  transition: all 0.2s ease;
  width: fit-content;
  
  &:hover {
    background-color: rgb(240, 245, 250);
    border-color: rgb(150, 180, 210);
  }
}

.info-icon-small {
  width: 16px;
  height: 16px;
}

.help-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 40px;
  z-index: 9999;
}

.help-popup {
  position: relative;
  background-color: white;
  border-radius: 8px;
  padding: 24px;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.help-popup--in-place {
  position: relative;
  width: 100%;
  max-width: none;
  max-height: none;
  box-sizing: border-box;
  padding: 8px 12px;
  border: 1px solid rgb(198, 198, 198);
  box-shadow: none;
}

.popup-content {
  display: flex;
  flex-direction: row;
  font-size: smaller;
  font-style: italic;
  
  &.alert-style {
    fill: rgb(121, 27, 27);
  }
}

.info-icon {
    width: 18px;
    margin: 2px;
    align-self: self-start;
}

.alert-icon {
    width: 18px;
    margin: 2px;
    align-self: self-start;
}

.info-text {
    padding-left: 10px;
    color: rgb(11, 40, 91);
    text-align: left;
}

.alert-text {
    padding-left: 10px;
    color: rgb(121, 27, 27);
    text-align: left;
}
</style>
